import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ExpandToggleIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
  expanded: boolean;
}

const ExpandToggleIcon: React.FC<ExpandToggleIconProps> = (props) => {
  const { expanded, strokeWidth = '1', ...svgProps } = props;

  return (
    <SvgIcon {...svgProps} viewBox="0 0 24 24" className="sx-icon-expand-toggle">
      {!expanded ? (
        <path
          d="M14 10 L20 4 M16 4 L20 4 L20 8 M10 14 L4 20 M4 16 L4 20 L8 20"
          fill="none"
          stroke={props.color || 'currentColor'}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M20 4 L14 10 M18 10 L14 10 L14 6 M4 20 L10 14 M6 14 L10 14 L10 18"
          fill="none"
          stroke={props.color || 'currentColor'}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </SvgIcon>
  );
};

export default ExpandToggleIcon;